<template >
  <div
    class="mx-3"
    style="
      min-height: 80vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    "
  >
    <section v-if="mode === 'home'" style="margin-left: 1em; margin-right: 1em">
      <AppAutoupdate :canUpdateNow="true"></AppAutoupdate>

      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          max-width: 18em;
        "
      >
        <br />
        <h3>
          <strong>
            <span v-if="user.privilegesObj.blindedResearcher">Blinded</span>
            <span v-if="user.privilegesObj.unblindedResearcher">Unblinded</span>
            Researcher Home
          </strong>
        </h3>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <div>&nbsp;</div>

        <b-button
          block
          size="lg"
          variant="primary"
          v-on:click="goOnboardingList()"
          style="border-radius: 0.5em"
          class="d-flex"
        >
          <font-awesome-icon
            icon="handshake"
            style="height: 2em; width: 2em"
            class="mr-4"
          />
          <div class="megabutton-text">
            <div class="title">Set up participant</div>
            <div class="subtitle">Name, phone, dates etc</div>
          </div>
        </b-button>

        <b-button
          v-if="
            user.privilegesObj.blindedResearcher ||
            user.privilegesObj.unblindedResearcher
          "
          block
          size="lg"
          variant="primary"
          v-on:click="goMonitorList"
          style="border-radius: 0.5em"
          class="d-flex"
        >
          <div>
            <font-awesome-icon
              icon="people-carry"
              style="height: 2em; width: 2em"
              class="mr-4"
            />
          </div>
          <div class="megabutton-text">
            <div class="title">Data Monitoring</div>
            <div class="subtitle">Live-Assist or Summary</div>
          </div>
        </b-button>

        <b-button
          v-if="
            user.privilegesObj.blindedResearcher ||
            user.privilegesObj.unblindedResearcher
          "
          block
          size="lg"
          variant="primary"
          @click="goExport"
          style="border-radius: 0.5em"
          class="d-flex"
        >
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="2em"
            height="2em"
            style="fill: white"
            x="0px"
            y="0px"
            viewBox="0 0 1000 1000"
            enable-background="new 0 0 1000 1000"
            xml:space="preserve"
            class="mr-4"
          >
            <g>
              <path
                d="M990,843.9L797.1,694.9V765h-228v157.8l0,0h228V993L990,843.9z"
              />
              <path
                d="M405.3,913C210.7,902.8,89,854.6,89,796.6V712c68.7,43.2,178.7,73.8,316.3,82.2v-78.6C210.7,705.4,89,657.2,89,599.2v-84.6c81.2,51.1,220.4,84.6,394.8,84.6c79.5,0,151.7-7,214.4-19.4l1.1-76.9c-59.7,11-132.5,17.4-215.5,17.4c-239.8,0-394.8-53-394.8-118.4v-84.6c81.2,51.1,220.4,84.6,394.8,84.6c174.4,0,313.5-33.5,394.8-84.6v84.6c0,34.2-42.4,65-117.1,86.7l62.1,54.4c20.5-8.6,38.9-18.1,55-28.2v76.4l79,69.1V204.4C957.5,95.4,767.2,7,483.8,7C200.3,7,10,95.4,10,204.4v592.2c0,98.6,155.7,180.4,395.3,195L405.3,913L405.3,913z M483.8,86c239.8,0,394.8,53,394.8,118.4c0,65.4-155,118.4-394.8,118.4c-239.8,0-394.8-53-394.8-118.4C89,139,243.9,86,483.8,86z"
              />
            </g>
          </svg>

          <div class="megabutton-text">
            <div class="title">Export data</div>
            <div class="subtitle">&nbsp;</div>
          </div>
        </b-button>
      </div>
    </section>

    <section v-if="mode === 'onboardingList'">
      <AppAutoupdate :canUpdateNow="true"></AppAutoupdate>

      <h3>
        <b-button variant="link" v-on:click="goHome()">
          <font-awesome-icon icon="home" />
        </b-button>
        <span class="divider">|&nbsp;</span>
        Setup
      </h3>

      <b-button variant="link" v-b-toggle.newParticipantSteps
        >How do I set up a participant?</b-button
      >
      <b-collapse id="newParticipantSteps">
        <ResViewNewParticipantHelp></ResViewNewParticipantHelp>
      </b-collapse>

      <b-table
        responsive
        striped
        hover
        :items="presenceArrayEligibleForOnboarding"
        :fields="fieldsOnboarding"
        sort-by="dLastLogin"
        :sort-desc="true"
        v-on:row-clicked="oneParticipantOnboardingFromItem"
      >
        <!-- <template slot="isParticipant" slot-scope="table">
          {{ privilegesSummaryString(privilegesRootObj[table.item.id])}}
        </template>-->
      </b-table>
    </section>

    <section v-if="mode === 'onboardingOne'">
      <AppAutoupdate :canUpdateNow="false"></AppAutoupdate>

      <h4>
        <b-button variant="link" v-on:click="goHome()">
          <font-awesome-icon icon="home" />
        </b-button>
        <span class="divider">|&nbsp;</span>
        <b-button variant="link" v-on:click="goOnboardingList()">
          <font-awesome-icon icon="list" />
        </b-button>
        <span class="divider">|&nbsp;</span>
        Set up
        {{
          participant.contactObj.shortName ||
          participant.presenceObj.emailAtLastLogin ||
          participant.contactObj.trialId ||
          "one person"
        }}
      </h4>

      <h5 v-if="!participant.contactObj.shortName">
        {{ participant.presenceObj.emailAtLastLogin }}
      </h5>

      <b-form>
        <br />
        <b-form-group
          label="Activate as a participant"
          label-size="lg"
          label-class="font-weight-bold"
        >
          <b-form-checkbox
            v-model="participant.privilegesObj.participant"
            @change="
              participant.privilegesRef
                .child('participant')
                .set(participant.privilegesObj.participant)
            "
            >Is a trial participant</b-form-checkbox
          >
          <p style="font-size: 71%">
            i.e. allow them to access symptom entry module
          </p>

          <div v-if="participant.privilegesObj.participant">
            <b-form-checkbox
              v-model="participant.privilegesObj.participantCompleted"
              @change="
                participant.privilegesRef
                  .child('participantCompleted')
                  .set(participant.privilegesObj.participantCompleted)
              "
              >Has completed participation</b-form-checkbox
            >
            <p style="font-size: 71%">i.e. omit from daily chasing-up list</p>
          </div>
          <br />
        </b-form-group>

        <div v-if="participant.privilegesObj.participant === true">
          <div
            v-if="
              !participant.statusObj.privacy ||
              !participant.statusObj.privacy.agree
            "
          >
            <b-alert show variant="primary">
              <h3>Ask them to read their privacy policy</h3>
              <hr />
              <p>They can do that while you continue setting them up.</p>
            </b-alert>
          </div>

          <b-form-group
            label="Identity"
            label-size="lg"
            label-class="font-weight-bold"
          >
            <b-form-row class="align-items-center mb-3">
              <b-col>
                Email
                <span style="font-size: 70%">non-editable</span>
              </b-col>
              <b-col>
                <span style="color: gray">{{
                  participant.presenceObj.emailAtLastLogin
                }}</span>
              </b-col>
            </b-form-row>

            <b-form-group
              label="Short name"
              description="Will show at top of their screen."
            >
              <b-form-input
                type="text"
                v-model="participant.contactObj.shortName"
                required
                placeholder="e.g. Bill"
                v-on:change="
                  participant.contactRef
                    .child('shortName')
                    .set(participant.contactObj.shortName)
                "
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Trial ID">
              <b-form-input
                type="text"
                v-model="participant.contactObj.trialId"
                required
                v-on:change="
                  participant.contactRef
                    .child('trialId')
                    .set(participant.contactObj.trialId)
                "
              ></b-form-input>
            </b-form-group>
          </b-form-group>

          <b-form-group
            vertical
            label="Phone numbers"
            label-size="lg"
            label-class="font-weight-bold"
          >
            <b-form-row class="align-items-center">
              <b-col>Mobile</b-col>
              <b-col>
                <b-form-input
                  type="text"
                  required
                  v-model="participant.contactObj.mobileSelf"
                  v-on:change="
                    participant.contactRef
                      .child('mobileSelf')
                      .set(participant.contactObj.mobileSelf)
                  "
                ></b-form-input>
              </b-col>
            </b-form-row>

            <b-form-row class="align-items-center">
              <b-col>Home landline</b-col>
              <b-col>
                <b-form-input
                  type="text"
                  v-model="participant.contactObj.homeLandline"
                  v-on:change="
                    participant.contactRef
                      .child('homeLandline')
                      .set(participant.contactObj.homeLandline)
                  "
                  placeholder="optional"
                ></b-form-input>
              </b-col>
            </b-form-row>

            <br />

            <b-form-row class="align-items-center">
              <b-col>Alternative contact's mobile</b-col>
              <b-col>
                <b-form-input
                  type="text"
                  v-model="participant.contactObj.mobileAlternative"
                  v-on:change="
                    participant.contactRef
                      .child('mobileAlternative')
                      .set(participant.contactObj.mobileAlternative)
                  "
                  placeholder="optional"
                ></b-form-input>
              </b-col>
            </b-form-row>

            <b-form-row
              v-if="participant.contactObj.mobileAlternative"
              class="align-items-center"
            >
              <b-col>Who is alt contact?</b-col>
              <b-col>
                <b-form-input
                  type="text"
                  v-model="participant.contactObj.mobileAlternativeWho"
                  v-on:change="
                    participant.contactRef
                      .child('mobileAlternativeWho')
                      .set(participant.contactObj.mobileAlternativeWho)
                  "
                  placeholder="e.g. wife Sylvia"
                ></b-form-input>
              </b-col>
            </b-form-row>
          </b-form-group>

          <b-form-group
            label="What is your angina like?"
            label-size="lg"
            label-class="font-weight-bold"
          >
            <div>
              Examples of desired grammatical structure of an answer:
              <ul>
                <li>
                  a pin-point pain in
                  <strong>my</strong> right ear
                </li>
                <li>
                  itchiness of
                  <strong>my</strong> left foot
                </li>
              </ul>
            </div>
            <b-form-input
              type="text"
              v-model="participant.contactObj.myAnginaIs"
              v-on:change="
                participant.contactRef
                  .child('myAnginaIs')
                  .set(participant.contactObj.myAnginaIs)
              "
              placeholder
            ></b-form-input>

            <b-alert
              show
              variant="danger"
              v-if="
                participant.contactObj.myAnginaIs &&
                participant.contactObj.myAnginaIs.charAt(0).toLowerCase() !==
                  participant.contactObj.myAnginaIs.charAt(0)
              "
              >Please don't capitalise as it messes up the help
              message.</b-alert
            >
            <b-alert
              show
              variant="danger"
              v-if="
                participant.contactObj.myAnginaIs &&
                participant.contactObj.myAnginaIs.charAt(
                  participant.contactObj.myAnginaIs.length - 1
                ) === '.'
              "
              >Please don't end with a full stop. We automatically add one when
              putting in a sentence.</b-alert
            >

            <div v-if="participant.contactObj.myAnginaIs">
              The participant's help message will be this:
              <MyAnginaIs
                :text="participant.contactObj.myAnginaIs"
              ></MyAnginaIs>
            </div>
          </b-form-group>

          <b-form-group
            label="Activities"
            label-size="lg"
            label-class="font-weight-bold"
          >
            <b-form-row class="align-items-center">
              <ResViewAnginaTrigger
                text="Mild activity is ..."
                :fbRef="
                  participant.contactRef.child('windows/questions/activity_001')
                "
              ></ResViewAnginaTrigger>
            </b-form-row>

            <b-form-row class="align-items-center">
              <ResViewAnginaTrigger
                text="Moderate activity is ..."
                :fbRef="
                  participant.contactRef.child('windows/questions/activity_002')
                "
              ></ResViewAnginaTrigger>
            </b-form-row>
          </b-form-group>

          <b-form-group
            label="Days of symptoms to capture"
            label-size="lg"
            label-class="font-weight-bold"
          >
            <b-form-row
              class="align-items-center"
              style="padding-bottom: 0.3em"
            >
              <b-col>
                <strong>First</strong> day being recorded
                <!-- {{windowDisplayNames[windowKey[0]]}} -->
              </b-col>
              <b-col>
                <v-date-picker
                  onkeydown="return false"
                  :value="
                    new Date(participant.contactObj.startDateKey) || new Date()
                  "
                  :formats="datePickerFormats"
                  v-on:dayclick="
                    (dObj) => {
                      participant.contactRef
                        .child('startDateKey')
                        .set(convertFromDateObjToDateKey(dObj.date));
                    }
                  "
                ></v-date-picker>
              </b-col>
              <b-col v-if="participant.contactObj.startDateKey">
                <b-button
                  class="btn-sm btn-success"
                  v-on:click="fillPrerandomizationWindows(participant)"
                  >Fill baseline 2 weeks</b-button
                >
              </b-col>
            </b-form-row>

            <div>
              <b-form-row>
                <b-col>
                  <small
                    >After entering the first day, click "Fill" button rather
                    than manually calculating, because ~1/3 of manual
                    calculations are wrong. Humans are vulnerable to fencepost
                    errors.</small
                  >
                </b-col>
              </b-form-row>
            </div>

            <div
              v-for="(windowKey, iWindow) in windowKeys"
              :key="windowKey"
              style="padding-bottom: 0.3em"
              class="align-items-center"
            >
              <div v-if="iWindow === 2">
                <b-form-row
                  style="color: red; font-weight: 900; font-size: 200%"
                  >&thinsp;STOP</b-form-row
                >
                <b-form-row style="color: red; font-weight: 700"
                  >&nbsp;When initially setting up the patient, DO NOT fill in
                  any dates below.</b-form-row
                >
                <b-form-row style="color: red; font-weight: 700"
                  >&nbsp;Wait until the randomized, blinded procedure is
                  actually happening.</b-form-row
                >
                <b-form-row>
                  &nbsp;Even if you &nbsp;
                  <em>think</em> &nbsp; you know the future date of the
                  procedure, don't enter it in advance.
                </b-form-row>
                <b-form-row>&nbsp;</b-form-row>
              </div>

              <b-form-row>
                <b-col
                  >Last day of {{ windowDisplayNames[iWindow]
                  }}{{ windowDurationIfAvailable(windowKey) }}</b-col
                >
                <b-col>
                  <v-date-picker
                    onkeydown="return false"
                    :value="
                      new Date(
                        participant.contactObj.windows &&
                          participant.contactObj.windows.dates &&
                          participant.contactObj.windows.dates[windowKey] &&
                          participant.contactObj.windows.dates[windowKey]
                            .endDateKey
                      )
                    "
                    :formats="datePickerFormats"
                    v-on:dayclick="
                      (dObj) => {
                        participant.contactRef
                          .child('windows/dates')
                          .child(windowKey)
                          .child('endDateKey')
                          .set(convertFromDateObjToDateKey(dObj.date));
                      }
                    "
                  ></v-date-picker>
                </b-col>
                <b-col>
                  <b-button
                    v-if="
                      participant.contactObj.windows &&
                      participant.contactObj.windows.dates &&
                      participant.contactObj.windows.dates[windowKey] &&
                      participant.contactObj.windows.dates[windowKey]
                        .endDateKey &&
                      iWindow >= 2
                    "
                    class="btn-sm btn-light"
                    v-on:click="fillDownWeekly(participant, windowKey)"
                    >Fill down weekly</b-button
                  >
                </b-col>
              </b-form-row>
              <div v-if="iWindow === 2">
                <b-form-row style="font-size: 71%"
                  >&nbsp;&nbsp;After this date, unblinded researchers can no
                  longer access this participant</b-form-row
                >
                <br />
              </div>
            </div>
          </b-form-group>
        </div>
        <b-button variant="primary" size="lg" v-on:click="goOnboardingList()"
          >&nbsp; &nbsp; OK &nbsp; &nbsp;</b-button
        >

        <br />
        <br />
        <hr />
        <br />
        <b-form-group
          label="Advanced stuff, rarely needed"
          label-size="lg"
          label-class="font-weight-bold"
        >
          <b-form-row class="align-items-center">
            <b-col>Authentication Id</b-col>
            <b-col>{{ participant.id }}</b-col>
          </b-form-row>

          <br />
          <b-form-row
            v-if="participant.statusObj && participant.statusObj.trained"
            class="align-items-center"
          >
            <b-col>If they have forgotten how to use this app</b-col>
            <b-col>
              <b-button
                variant="secondary"
                v-on:click="
                  participant.statusRef.child('trained').set(false);
                  triggerParticipantScreenRefresh();
                "
                >Force them to redo training</b-button
              >
            </b-col>
          </b-form-row>

          <b-form-row
            v-if="participant.statusObj && !participant.statusObj.trained"
            class="align-items-center"
          >
            <b-col>If they don't need training</b-col>
            <b-col>
              <b-button
                variant="secondary"
                v-on:click="
                  participant.statusRef.child('trained').set(true);
                  triggerParticipantScreenRefresh();
                "
                >Skip training</b-button
              >
            </b-col>
          </b-form-row>
        </b-form-group>
      </b-form>
    </section>

    <section v-if="mode === 'monitorList'">
      <AppAutoupdate :canUpdateNow="true"></AppAutoupdate>
      <h3>
        <b-button v-on:click="goHome()" variant="link">
          <font-awesome-icon icon="home" /> </b-button
        >Data Monitoring
      </h3>

      <!-- <ToggleSwitch v-model="onlyShowOrbita2" :labels="{checked:'Limit to real ORBITA-2',unchecked:'Show test people too'}" width="200"></ToggleSwitch> -->
      <b-form-checkbox v-model="onlyShowOrbita2"
        >Only Ids containing "ORBITA2"</b-form-checkbox
      >
      <b-form-checkbox v-model="onlyShowIncomplete"
        >Only show participants still in trial</b-form-checkbox
      >

      <b-table
        striped
        hover
        :items="participantMingledAccessibleByResearcher"
        :fields="fieldsMonitor"
        sort-by="completeToDateKey"
        style="table-layout: fixed; word-break: break-word"
      >
        <template #cell(actions)="thingContainingItem">
          <b-button
            @click="goMonitorOneFromItem(thingContainingItem.item)"
            size="sm"
            variant="light"
            class="m-1"
            >Live-assist</b-button
          >
          <b-button
            @click="goDisplayOneFromItem(thingContainingItem.item)"
            size="sm"
            variant="light"
            class="m-1"
            >Summary</b-button
          >
        </template>
      </b-table>
    </section>

    <section
      v-if="
        mode === 'monitorOne' &&
        participant.privilegesIsLoaded &&
        participant.statusIsLoaded &&
        participant.contactIsLoaded
      "
    >
      <AppAutoupdate :canUpdateNow="false"></AppAutoupdate>

      <h4>
        <b-button variant="link" v-on:click="goHome()">
          <font-awesome-icon icon="home" />
        </b-button>
        <span class="divider">|&nbsp;</span>
        <b-button variant="link" v-on:click="goMonitorList()">
          <font-awesome-icon icon="list" />
        </b-button>
        <span class="divider">|&nbsp;</span>
        Live-assist
      </h4>
      <h6 class="mx-2">
        {{ participant.contactObj.trialId }}
        &nbsp;
        <b-button variant="success">
          <a
            v-bind:href="'tel:' + participant.contactObj.mobileSelf"
            style="color: white"
          >
            {{ participant.contactObj.mobileSelf }} &nbsp;
            <font-awesome-icon icon="phone" />
          </a> </b-button
        >&nbsp;
        <b-button variant="outline-primary" v-b-toggle.showAlternateContacts
          >Alt Contact</b-button
        >
      </h6>

      <b-collapse id="showAlternateContacts">
        <b-form-row class="align-items-center mb-3">
          <b-col>Email</b-col>
          <b-col>{{ participant.presenceObj.emailAtLastLogin }}</b-col>
        </b-form-row>

        <b-form-row class="align-items-center mb-3">
          <b-col>Home landline</b-col>
          <b-col>{{
            participant.presenceObj.homeLandline || "none given"
          }}</b-col>
        </b-form-row>

        <b-form-row class="align-items-center mb-3">
          <b-col>{{
            participant.contactObj.mobileAlternativeWho || "Alternative contact"
          }}</b-col>
          <b-col>{{
            participant.contactObj.mobileAlternative || "none given"
          }}</b-col>
        </b-form-row>
      </b-collapse>

      <div class="phone-aspect-ratio-container">
        <div class="phone-outer">
          <div class="phone-inner">
            <div v-if="participant.statusObj.trained">
              <HeaderBand
                v-bind:name="
                  typeof participant.contactObj.shortName === 'string'
                    ? participant.contactObj.shortName
                    : 'Name not given yet'
                "
              ></HeaderBand>
              <SymptomEntry
                v-bind:participant="participant"
                entryMode="live"
              ></SymptomEntry>
            </div>
            <div v-else>
              <HeaderBand name="Practice Mode"></HeaderBand>
              <SymptomEntry
                v-bind:participant="participant"
                entryMode="practice"
              ></SymptomEntry>
            </div>
          </div>
        </div>
      </div>
      <p class="m-2">
        If speaking to participant, remember their screen(s) may have different
        size, shape and orientation, so (for example) they may need to scroll
        even when you don't.
      </p>
    </section>

    <section
      v-if="
        mode === 'displayOne' &&
        participant.privilegesIsLoaded &&
        participant.statusIsLoaded &&
        participant.contactIsLoaded
      "
    >
      <AppAutoupdate :canUpdateNow="false"></AppAutoupdate>

      <h4>
        <b-button variant="link" v-on:click="goHome()">
          <font-awesome-icon icon="home" />
        </b-button>
        <span class="divider">|&nbsp;</span>
        <b-button variant="link" v-on:click="goMonitorList()">
          <font-awesome-icon icon="list" />
        </b-button>
        <span class="divider">|&nbsp;</span>
        Summary of data history
      </h4>
      <h6 class="mx-2">
        {{ participant.contactObj.trialId }}
        &nbsp;
        <b-button variant="success">
          <a
            v-bind:href="'tel:' + participant.contactObj.mobileSelf"
            style="color: white"
          >
            {{ participant.contactObj.mobileSelf }} &nbsp;
            <font-awesome-icon icon="phone" />
          </a> </b-button
        >&nbsp;
        <b-button variant="outline-primary" v-b-toggle.showAlternateContacts
          >Alt Contact</b-button
        >
      </h6>

      <b-collapse id="showAlternateContacts">
        <b-form-row class="align-items-center mb-3">
          <b-col>Email</b-col>
          <b-col>{{ participant.presenceObj.emailAtLastLogin }}</b-col>
        </b-form-row>

        <b-form-row class="align-items-center mb-3">
          <b-col>Home landline</b-col>
          <b-col>{{
            participant.presenceObj.homeLandline || "none given"
          }}</b-col>
        </b-form-row>

        <b-form-row class="align-items-center mb-3">
          <b-col>{{
            participant.contactObj.mobileAlternativeWho || "Alternative contact"
          }}</b-col>
          <b-col>{{
            participant.contactObj.mobileAlternative || "none given"
          }}</b-col>
        </b-form-row>
      </b-collapse>

      <HeaderBand
        v-bind:name="
          typeof participant.contactObj.shortName === 'string'
            ? participant.contactObj.shortName
            : 'Name not given yet'
        "
      ></HeaderBand>

      <div
        v-if="
          participant && participant.statusObj && participant.statusObj.live
        "
      >
        <h3>{{ participant.contactObj.trialId }}</h3>
        <h4>Daily data</h4>
        <div>Date, Yes or No, Frequency, Severity (out of 600)</div>
        <div
          v-for="(dayData, dayKey) in (participant.statusObj.live || {}).days"
          :key="dayKey"
        >
          {{ dayKey }},

          <span
            :class="{
              emphasise: dayData.anginaCount > 0,
            }"
            >{{ dayData.anginaYesNo }},
            {{ dayData.anginaCount || 0 }}
            ,
            {{ dayData.anginaSeverity || 0 }}</span
          >
          <br />
        </div>

        <br />
        <h4>Long-window data (e.g. weekly)</h4>
        <div>Window, Activity, Yes or No</div>
        <div
          v-for="(windowData, windowKey) in (participant.statusObj.live || {})
            .windows"
          :key="windowKey"
        >
          <div
            v-for="(activityData, activityKey) in windowData.questions"
            :key="activityKey"
          >
            {{ windowKeyToDisplayName(windowKey) }}, {{ activityKey }},
            <span
              :class="{
                emphasise: activityData.anginaYesNo === 'Yes',
              }"
            >
              {{ activityData.anginaYesNo }}
            </span>
          </div>
        </div>
      </div>

      <div v-else>
        <h4>No data</h4>
      </div>
    </section>

    <!--
  _____                       _
 | ____|_  ___ __   ___  _ __| |_
 |  _| \ \/ / '_ \ / _ \| '__| __|
 | |___ >  <| |_) | (_) | |  | |_
 |_____/_/\_\ .__/ \___/|_|   \__|
            |_| -->
    <section v-if="mode === 'export'">
      <h3>
        <b-button id="researcher-home-button" @click="goHome()" variant="link">
          <font-awesome-icon icon="home" /> </b-button
        >Data Export
      </h3>

      <DataExport
        :participantIdArray="participantIdArray"
        :contactRootObj="contactRootObj"
        :statusRootRef="statusRootRef"
      >
      </DataExport>
    </section>
  </div>
</template>

<script>
/* eslint-disable standard/computed-property-even-spacing */

import SymptomEntry from "./SymptomEntry.vue";
import ResViewNewParticipantHelp from "./ResViewNewParticipantHelp.vue";
import HeaderBand from "./HeaderBand.vue";
import MyAnginaIs from "./MyAnginaIs.vue";
import ResViewAnginaTrigger from "./ResViewAnginaTrigger.vue";
import AppAutoupdate from "./AppAutoupdate.vue";
import DataExport from "./DataExport.vue";

import {
  // auth,
  // systemStatusRef,
  contactRootRef,
  privilegesRootRef,
  presenceRootRef,
  statusRootRef, // For exports
  //  statusRootRef
  //  ServerValueTIMESTAMP
} from "../firebaseSetup.js";

export default {
  components: {
    SymptomEntry,
    ResViewNewParticipantHelp,
    HeaderBand,
    MyAnginaIs,
    ResViewAnginaTrigger,
    AppAutoupdate,
    DataExport,
  },

  props: ["user", "participant", "bindParticipantToAUserId"],

  data: () => ({
    mode: "home", // "overview","onboardingList","onboardingOne","monitorList","monitorOne"

    contactRootObj: {},
    privilegesRootObj: {},
    presenceRootObj: {},
    presenceRootArray: [],
    presenceRootArrayEligibleForOnboarding: [],
    // statusRootObj: {},
    statusRootRef: statusRootRef,
    participantIdArray: [],
    participantMingledArray: [],
    // PRIVILEGES, CONTACTS, PRESENCE datasets, which are small enough to hold for all patients in memory at once, but not STATUS which is too large volume to hold everyone's at once.

    onlyShowOrbita2: true,
    onlyShowIncomplete: true,

    fieldsOnboarding: [
      {
        key: "emailAtLastLogin",
        label: "Email",
        sortable: true,
        class: "tableEmail",
        formatter: (email) =>
          (email || "No email").replace("@", "\u200A@\u200A"),
      },
      { key: "trialId", sortable: true },
      {
        key: "dLastLogin",
        formatter: (serverTimeInt) =>
          new Intl.DateTimeFormat("en-GB", {
            hour: "numeric",
            minute: "numeric",
            timeZoneName: "short",
            day: "numeric",
            month: "short",
            year: "2-digit",
          }).format(new Date(serverTimeInt || 0)),
        label: "Last refreshed",
        sortable: true,
        class: "tableDate",
      },
      // {
      //   key: "lastChangeWasOn",
      //   formatter: value => (value ? "Online" : ""),
      //   label: "Online",
      //   sortable: true
      // },

      // {
      //   key: "isParticipant",
      //   label: "Participant?"
      // }
    ],

    fieldsMonitor: [
      {
        key: "completeToDateKey",
        sortable: true,
        label: "Done up to",
      },
      { key: "trialId", sortable: true },
      //      { key: "emailAtLastLogin", label: "Email", sortable: true },
      // {
      //   key: "lastChangeWasOn",
      //   formatter: value => (value ? "On" : "-"),
      //   label: "Online?",
      //   sortable: true
      // },
      // {
      //   key: "dLastLogin",
      //   formatter: serverTimeInt =>
      //     new Intl.DateTimeFormat("en-GB", {
      //       hour: "numeric",
      //       minute: "numeric",
      //       timeZoneName: "short",
      //       day: "numeric",
      //       month: "short",
      //       year: "2-digit"
      //     }).format(new Date(serverTimeInt || 0)),
      //   label: "Last refreshed",
      //   sortable: true
      // },
      {
        key: "actions",
        /* This will be filled in with the action buttons in the template */
      },
    ],

    datePickerFormats: {
      input: ["YYYY-MM-DD"],
      data: ["YYYY-MM-DD"],
      dayPopover: "L",
    },

    showNewParticipantHelp: false,
  }),

  computed: {
    presenceArrayEligibleForOnboarding: function () {
      const todayKey = new Date().toISOString().slice(0, 10);

      const presenceRootArraySubset = this.presenceRootArray.filter(
        (presenceItem) => {
          const id = presenceItem.id;

          const p = this.contactRootObj[id] || { shortName: "No name" };
          const isResearcher = // and therefore not eligible to be onboarded
            this.privilegesRootObj[id] &&
            (this.privilegesRootObj[id].blindedResearcher ||
              this.privilegesRootObj[id].unblindedResearcher);

          const participantNowBlinded =
            p &&
            p.windows &&
            p.windows.dates &&
            p.windows.dates.window_003 &&
            p.windows.dates.window_003.endDateKey &&
            p.windows.dates.window_003.endDateKey < todayKey;

          // Participant must obviously not be a researcher, and then the researcher doing the onboarding must EITHER be blinded (can look at data any time) OR unblinded (in which case they can only look at patient until patient is randomized/blinded)

          const eligible =
            !isResearcher &&
            (this.user.privilegesObj.blindedResearcher ||
              (this.user.privilegesObj.unblindedResearcher &&
                !participantNowBlinded));

          return eligible;
        }
      );

      return presenceRootArraySubset.map((presenceObj) => ({
        ...presenceObj,
        trialId:
          (this.contactRootObj &&
            this.contactRootObj[presenceObj.id] &&
            this.contactRootObj[presenceObj.id].trialId) ||
          "-",
      }));
    },

    participantMingledAccessibleByResearcher: function () {
      // You can Monitor Data Entry on a participant who has NOT completed, as long as EITHER you are blinded OR the patient is still in the pre-blinding period.

      const todayKey = new Date().toISOString().slice(0, 10);

      // Initial superset
      let participants = this.participantMingledArray.filter(
        (participantMingled) =>
          participantMingled.participant &&
          (participantNotBlindedYet(participantMingled) ||
            this.user.privilegesObj.blindedResearcher)
      );

      // Limit to ORBITA trial IDs, if requested
      if (this.onlyShowOrbita2) {
        participants = participants.filter((pm) =>
          (pm.trialId || "").includes("ORBITA2")
        );
      }

      // Limit to non-completed patients, if requested
      if (this.onlyShowIncomplete) {
        participants = participants.filter((pm) => !pm.participantCompleted);
      }

      return participants;

      // Helper functions follow:

      function participantNotBlindedYet(
        // a helper function that processes a participantMingled. This gets hoisted so it is available in the RETURN statement of the parent function
        p
      ) {
        return (
          p &&
          p.windows &&
          p.windows.dates &&
          p.windows.dates.window_003 &&
          p.windows.dates.window_003.endDateKey &&
          !(p.windows.dates.window_003.endDateKey < todayKey)
        );
      }
    },

    calendarAttrsContactStartDateKey: function (dateKey) {
      return [
        {
          key: "today",
          highlight: {
            backgroundColor: "#ff8080",
          },
          // Just use a normal style
          contentStyle: {
            color: "#fafafa",
          },
          dates: new Date(dateKey),
        },
      ];
    },
  },

  created() {
    // CONSTANTS

    this.windowDisplayNames = [
      "Baseline 1",
      "Baseline 2",
      "Baseline wait, i.e. DATE OF PROCEDURE",
      "Blinded  1",
      "Blinded  2",
      "Blinded  3",
      "Blinded  4",
      "Blinded  5",
      "Blinded  6",
      "Blinded  7",
      "Blinded  8",
      "Blinded  9",
      "Blinded 10",
      "Blinded 11",
      "Blinded 12",
      "Blinded wait to unblinding",
    ];
    this.nWindows = 3 + 13;
    this.window1toN = [...Array(this.nWindows + 1).keys()].slice(1);
    this.windowKeys = this.window1toN.map(
      (i) => "window_" + ("000" + i).slice(-3)
    );

    // BOOTUP BINDINGS

    // A good way to get list of PARTICIPANTS is to look at the privileges object because (a) All participants must have a "true" in the participants property, and (b) It doesn't change much so there is little unnecessary reactivity

    privilegesRootRef.on("value", (snapshot) => {
      // Do repeatedly on change
      this.privilegesRootObj = snapshot.val();
      this.updateParticipantMingledArray();
    });

    contactRootRef.on("value", (snapshot) => {
      this.contactRootObj = snapshot.val();
      this.updateParticipantMingledArray();
    });

    presenceRootRef.on("value", (snapshot) => {
      this.presenceRootObj = snapshot.val();
      this.updateParticipantMingledArray();

      // We need this for onboarding, separate from the Joined Participant array because people aren't participants yet so won't be on the participants array
      this.presenceRootArray = Object.keys(this.presenceRootObj).map((id) => ({
        ...this.presenceRootObj[id],
        id,
      }));
    });

    // This notifies all computers on which the researcher is logged in to react to changes in mode, i.e. to go to the same page so he can easily call them on the phone after selecting their record on the desktop computer.
    presenceRootRef
      .child(this.user.id)
      .child("resView")
      .on("value", (snapshot) =>
        this.researcherAllScreensRespondToChangeInMode(snapshot.val())
      );
  },

  filters: {
    phone(raw) {
      const bare = raw.replace(/[ -]/g, "");
      if (
        bare.charAt(0) === "0" &&
        bare.charAt(1) >= 1 &&
        bare.charAt(1) <= 9
      ) {
        if (bare.charAt(1) === "7") {
          return bare.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, "$1 $2 $3 $4");
        } else {
          return bare.replace(/(\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
        }
      }
    },
  },

  methods: {
    windowKeyTo1toN(windowKey) {
      return this.windowKeys.indexOf(windowKey);
    },

    windowKeyToDisplayName(windowKey) {
      const i = this.windowKeyTo1toN(windowKey);
      if (i >= 0) {
        return this.windowDisplayNames[i];
      } else {
        return "Unknown windowKey: " + windowKey;
      }
    },

    durationBetweenKeys(key1, key2) {
      const time1 = new Date(key1).getTime();
      const time2 = new Date(key2).getTime();
      const diffDays = Math.round((time2 - time1) / 86400000);
      return diffDays;
    },

    windowDurationIfAvailable(windowKey) {
      const startDateKey = this.participant.contactObj.startDateKey;
      const windowNumber = this.windowKeyTo1toN(windowKey);

      if (
        windowNumber === 0 &&
        startDateKey &&
        this.participant.contactObj &&
        this.participant.contactObj.windows &&
        this.participant.contactObj.windows.dates &&
        this.participant.contactObj.windows.dates[windowKey] &&
        this.participant.contactObj.windows.dates[windowKey].endDateKey
      ) {
        return (
          " (" +
          (this.durationBetweenKeys(
            startDateKey,
            this.participant.contactObj.windows.dates[windowKey].endDateKey
          ) +
            1) +
          "d)"
        );
      }

      if (
        windowNumber >= 1 &&
        this.participant.contactObj.windows.dates[windowKey]
      ) {
        const thisEndDateKey =
          this.participant.contactObj.windows.dates[windowKey].endDateKey;
        const previousWindowNumber = windowNumber - 1;
        const previousWindowKey = this.windowKeys[previousWindowNumber]; // e.g. window_005
        if (
          thisEndDateKey &&
          this.participant.contactObj.windows.dates[previousWindowKey] &&
          this.participant.contactObj.windows.dates[previousWindowKey]
            .endDateKey
        ) {
          const previousEndDateKey =
            this.participant.contactObj.windows.dates[previousWindowKey]
              .endDateKey;
          return (
            " (" +
            this.durationBetweenKeys(previousEndDateKey, thisEndDateKey) +
            "d)"
          );
        } else {
          return "";
        }
      }
    },

    triggerParticipantScreenRefresh: function () {
      // DUPLICATED -- naughtily --- in SYMPTOMENTRY
      // this is picked up by the firebase "ON" on the refresh node and triggers this.startSymptomEntryComponentAfresh() at the end of a setTimeout (to let the digest finish)
      this.participant.statusRef
        .child("refresh")
        .set(
          Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15)
        );
    },

    updateParticipantMingledArray() {
      // Produce an array containing all data of PARTICIPANTS (not just newly logged on people) EXCEPT the "STATUS" which is too large to load for all participants at once

      // Step 1. Get list of all participants, using "privileges" since all participants (and staff, but never mind) have an entry here.
      this.participantIdArray = Object.keys(this.privilegesRootObj).filter(
        (id) => ({
          id,
          ...this.privilegesRootObj[id].participant,
        })
      );

      // Step 2. Stick all the various arrays side-to-side into the MingledArray
      this.participantMingledArray = this.participantIdArray.map((id) => ({
        id,
        ...this.contactRootObj[id],
        ...this.privilegesRootObj[id],
        ...this.presenceRootObj[id],
        /* extra copy of this at the root of the object, so can be sorted by b-table; where no data inject something that sorts ABOVE all dates */
        completeToDateKey:
          ((this.presenceRootObj[id] || {}).progress || {}).completeToDateKey ||
          "- nil -",
      }));

      const todayKey = new Date().toISOString().slice(0, 10);
      this.participantMingledArray.forEach((p) => {
        const diffMs =
          new Date(todayKey).getTime() -
          new Date(p.completeToDateKey).getTime();
        const diffDays = Math.round(diffMs / 86400000);
        if (p.participantCompleted) {
          p._rowVariant = "light";
        } else if (diffDays <= 2) {
          p._rowVariant = "success";
        } else if (diffDays === 3) {
          p._rowVariant = "warning";
        } else {
          p._rowVariant = "danger";
        }
      });
    },

    // ===============================================================

    // To synch all the screens of a researcher together, when he changes mode, what he actually is doing is writing the desired mode to the PRESENCE object and then waiting for this to be bounced back to him (and all of his other logged in screens). This makes it easy to call patient from the research mobile phone if he is logged in there.

    researcherAllScreensRespondToChangeInMode(resView) {
      if (!resView) {
        resView = { mode: "home", participantId: null };
      }
      this.mode = resView.mode;
      if (resView.participantId) {
        this.bindParticipantToAUserId(resView.participantId); // Call my parent function that binds "this.participant" to the user id given here.
      }
    },
    oneParticipantOnboardingFromId(id) {
      this.user.presenceRef
        .child("resView")
        .update({ mode: "onboardingOne", participantId: id });
    },
    oneParticipantOnboardingFromItem(item) {
      this.oneParticipantOnboardingFromId(item.id);
    },
    goHome() {
      this.user.presenceRef
        .child("resView")
        .update({ mode: "home", participantId: null });
    },

    goOnboardingList() {
      this.user.presenceRef
        .child("resView")
        .update({ mode: "onboardingList", participantId: null });
    },

    goMonitorList() {
      this.user.presenceRef
        .child("resView")
        .update({ mode: "monitorList", participantId: null });
    },

    goExport() {
      this.user.presenceRef
        .child("resView")
        .update({ mode: "export", participantId: null });
    },

    goMonitorOneFromItem(item) {
      this.user.presenceRef
        .child("resView")
        .update({ mode: "monitorOne", participantId: item.id });
    },

    goDisplayOneFromItem(item) {
      this.user.presenceRef
        .child("resView")
        .update({ mode: "displayOne", participantId: item.id });
    },

    // ===============================================================
    privilegesSummaryString(privilegesObj) {
      let summaryList = [];
      if (!privilegesObj) {
        privilegesObj = {};
      }
      if (privilegesObj.participant) {
        summaryList.push("Participant");
      }
      if (privilegesObj.blindedResearcher) {
        summaryList.push("Blinded Researcher");
      }
      if (privilegesObj.unblindedResearcher) {
        summaryList.push("Unblinded Staff");
      }
      if (summaryList.length === 0) {
        summaryList.push("No role yet");
      }

      return summaryList.join(", ");
    },

    convertFromDateObjToDateKey: (dateObj) =>
      dateObj.getFullYear() +
      "-" +
      (" 0" + (dateObj.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + dateObj.getDate()).slice(-2),

    fillAllWindowsWeekly(thisParticipant) {
      const firstWindowKey = this.windowKeys[0];
      if (firstWindowKey) {
        // ... is not undefined
        let date = new Date(thisParticipant.contactObj.startDateKey);
        date.setDate(date.getDate() + 6); // 6 not 7, fencepost!
        const endDateKey = this.convertFromDateObjToDateKey(date);
        thisParticipant.contactRef
          .child("windows/dates")
          .child(firstWindowKey)
          .child("endDateKey")
          .set(endDateKey);

        // Manually write because reaction may not be in time, to allow the next function to run.
        thisParticipant.contactObj.windows.dates[firstWindowKey].endDateKey =
          endDateKey;

        // Then call for rest to be filled in
        this.fillDownWeekly(thisParticipant, firstWindowKey);
      }
    },

    fillPrerandomizationWindows(thisParticipant) {
      const firstWindowKey = this.windowKeys[0];
      if (firstWindowKey) {
        // ... is not undefined
        let date = new Date(thisParticipant.contactObj.startDateKey);

        date.setDate(date.getDate() + 6); // 6 not 7, fencepost!
        thisParticipant.contactRef
          .child("windows/dates")
          .child(firstWindowKey)
          .child("endDateKey")
          .set(this.convertFromDateObjToDateKey(date));

        date.setDate(date.getDate() + 7);
        thisParticipant.contactRef
          .child("windows/dates")
          .child(this.windowKeys[1])
          .child("endDateKey")
          .set(this.convertFromDateObjToDateKey(date));

        thisParticipant.contactRef
          .child("windows/dates")
          .child(this.windowKeys[2])
          .child("endDateKey")
          .set(null);
      }
    },

    fillDownWeekly(thisParticipant, windowKeyFromWhichToFill) {
      let currentEndDateKey = null;
      this.windowKeys.forEach((windowKey) => {
        if (windowKey === windowKeyFromWhichToFill) {
          currentEndDateKey =
            thisParticipant.contactObj.windows.dates[windowKey].endDateKey;
        } else if (windowKey > windowKeyFromWhichToFill) {
          let date = new Date(currentEndDateKey);

          if (windowKey === this.windowKeys[this.windowKeys.length - 1]) {
            // Typically we add a week, but for the last window we add a year to make it flexible-width
            // We err massively on the side of long-ness so that the window doesn't end (and the questions get asked) ahead of time.
            currentEndDateKey = null;
          } else {
            date.setDate(date.getDate() + 7);
            currentEndDateKey = this.convertFromDateObjToDateKey(date);
          }

          thisParticipant.contactRef
            .child("windows")
            .child("dates")
            .child(windowKey)
            .child("endDateKey")
            .set(currentEndDateKey);
        }
      });
    },
  },
};
</script>

<style>
/* Do not scope this style section because it will stop the table formatting (enabling word breaking of long emails) from working */

.megabutton-text {
  display: flex;
  flex-direction: column;
  align-items: start;
}

/* .title {
} */

.subtitle {
  font-size: 0.71em;
}

.divider {
  color: lightgray;
}

.phone-aspect-ratio-container {
  max-width: 30em;
  height: 50em;
}

.phone-outer {
  background: black;
  padding-top: 1em;
  padding-bottom: 3em;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 0.5em;
  height: 100%;
}
.phone-inner {
  background: white;
  padding: 0.5em;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
}

.tableEmail {
  max-width: 50%;
  word-break: break-word; /* for this to work, you mustn't SCOPE this STYLE */
}

.tableDate {
  max-width: 50%;
  word-break: break-word;
}

.emphasise {
  font-weight: 900;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/ResView.vue